import { createSelector } from "reselect";

const newMessageNotificationSelector = (state: TReduxState) =>
  state.features.newMessageNotification;

export const getNewMessageNotificationData = createSelector(
  newMessageNotificationSelector,
  (newMessageNotification) => newMessageNotification.notificationData
);
